import { render } from "./LivraisonCreate.vue?vue&type=template&id=24c57a06"
import script from "./LivraisonCreate.vue?vue&type=script&lang=js"
export * from "./LivraisonCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__